import { Fragment } from "react/jsx-runtime";
import type { GroupedEntry } from "./Transcript";
import { Message } from "./transcriptStyles";
import { UserActionGroup } from "./UserActionGroup";

type Props = {
  grouped: Extract<GroupedEntry, { type: "userActionGroup" }>;
  dateMarker: React.ReactNode;
  hasPrev: boolean;
  hasNext: boolean;
  expandedUserActionGroups: Set<string>;
  setExpandedUserActionGroups: React.Dispatch<
    React.SetStateAction<Set<string>>
  >;
};

export function UserActionGroupRow({
  grouped,
  dateMarker,
  hasPrev,
  hasNext,
  expandedUserActionGroups,
  setExpandedUserActionGroups,
}: Props) {
  return (
    <Fragment>
      {dateMarker}
      <Message
        style={{
          marginTop: hasPrev ? 16 : 0,
          marginBottom: hasNext ? 32 : 0,
        }}
      >
        <UserActionGroup
          entries={grouped.entries}
          collapsed={!expandedUserActionGroups.has(grouped.groupId)}
          toggleCollapsed={() =>
            setExpandedUserActionGroups((prev) => {
              const next = new Set(prev);
              if (next.has(grouped.groupId)) {
                next.delete(grouped.groupId);
              } else {
                next.add(grouped.groupId);
              }
              return next;
            })
          }
        />
      </Message>
    </Fragment>
  );
}
